import {
    getCategories,
    getItemSubscriptionFrequency,
    getQuantity
} from 'stores/ooka_uae_store/components/OOKA/pylot-gtm/src/mapping/functions'
import { MappingItem } from '@corratech/pylot-gtm/src/GTM'

export const upSellPromotionItemMapping = (
    categoryItems = getCategories
): MappingItem => {
    return {
        id: ['sku'],
        name: ['name'],
        currency: [
            ['price_range', 'minimum_price', 'final_price', 'currency'],
            ['prices', 'row_total_including_tax', 'currency']
        ],
        discount: ['price_range', 'minimum_price', 'discount', 'amount_off'],
        brand: ['brand_text'],
        category: categoryItems,
        price: [
            ['price_range', 'minimum_price', 'final_price', 'value'],
            ['price_range', 'minimum_price', 'regular_price', 'value']
        ],
        quantity: getQuantity,
        subscription_frequency: getItemSubscriptionFrequency
    }
}
